import React, { useState } from "react";
import { TouchableOpacity, Text, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import UpgradeModal from "../../screens/Auth/Event/UpgradeModal";
import { Image } from "react-native";
import { AppImages } from "../../utility/AppImages";

const UpgradeComponent = ({
  styles,
  fontStyle = AppFontStyle.BOLD_ANYBODY_20,
  imageIsVisible = true,
  title = "Upgrade",
  isUpdate = false,
}) => {
  const [isUpgrade, setIsUpgrade] = useState(false);

  return (
    <>
      <TouchableOpacity
        style={styles.upgradeBtn}
        onPress={() => {
          setIsUpgrade(true);
        }}
      >
        {imageIsVisible && (
          <View>
            <Image
              source={AppImages.vsUpgrade}
              style={{
                height: 45,
                width: 48,
                resizeMode: "contain",
              }}
            />
          </View>
        )}
        <View>
          <Text
            style={[
              fontStyle,
              {
                color: AppColors.white,
                alignSelf: "center",
              },
            ]}
          >
            {title}
          </Text>
        </View>
      </TouchableOpacity>
      {isUpgrade && (
        <UpgradeModal
          showModal={isUpgrade}
          setShowModal={setIsUpgrade}
          eventType={"HomeScreen"}
          isUpdate={isUpdate}
        />
      )}
    </>
  );
};

export default UpgradeComponent;
